import { StyledFlexColumn, StyledFlexRow } from "../../../styles/LayoutStyles";
import Form from "./form/Form";
import SelectedForm from "./form/selected/SelectedForm";
import LabelEditor from "./label_editor/LabelEditor";

function PrinterPageView({
  printerData,
  setPrinterData,
  fields,
  images,
  printerDevices,
  submitError,
  setSubmitError,
}) {
  return (
    <StyledFlexRow
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <LabelEditor
        printerData={printerData}
        setPrinterData={setPrinterData}
        fields={fields}
        images={images}
      />

      <StyledFlexColumn style={{ width: "400px", height: "100%" }}>
        <Form
          printerData={printerData}
          setPrinterData={setPrinterData}
          submitError={submitError}
          setSubmitError={setSubmitError}
          fields={fields}
          images={images}
          printerDevices={printerDevices}
        />

        <SelectedForm
          printerData={printerData}
          setPrinterData={setPrinterData}
          submitError={submitError}
          fields={fields}
          images={images}
        />
      </StyledFlexColumn>
    </StyledFlexRow>
  );
}

export default PrinterPageView;
